export const COHORT_LEVELS = [
    {
        name: 'countries',
        type: 'country',
    },
    {
        name: 'states',
        type: 'state',
    },
    {
        name: 'school districts',
        type: 'school_district',
    },
    {
        name: 'schools',
        type: 'schools',
    },
    {
        name: 'classes',
        type: 'classes',
    },
];

export function copy(list: any) {
    return JSON.parse(JSON.stringify(list));
}
